import { TemplateDetail } from '../../../types';
import { BulkExport, ExportFormats, ExportPayload } from '@qualio/export-components';
import { environment } from '../../../environments/environment';

type ExportOptions = {
  coverPageEnabled: boolean;
};

const createExportDataItem = (item: {
  bundle_path?: string;
  resource_description: string;
  export_payload: string;
  ignore_errors?: string[];
}) => item;

export const buildExportDocTemplatesPayload = (
  docTemplates: TemplateDetail[],
  companyId: number,
  currentUserName: string,
  isBulkExport: boolean,
  queryParams: ExportOptions,
): ExportPayload => {
  const { coverPageEnabled } = queryParams;

  return {
    exports: [
      {
        format: ExportFormats.bulk,
        data: docTemplates.flatMap((template) => {
          const { id, template_uuid } = template;
          const doc_template_id = String(id);
          const params = new URLSearchParams({
            generated_by: currentUserName,
            include_cover_page: String(coverPageEnabled),
            ...(template_uuid && { template_uuid }),
            ...(doc_template_id && { doc_template_id }),
          });
          return [
            createExportDataItem({
              resource_description: `Document template ${template.prefix} ${template.name}`.slice(0, 100),
              export_payload: `${
                environment.MEDTECH_API
              }/companies/${companyId}/document_templates/export-payload?${params.toString()}`,
            }),
          ].filter(Boolean) as BulkExport['data'];
        }),
      },
    ],
    metadata: {
      domain: 'document-template',
      resource_name: isBulkExport
        ? 'Bulk document template export'
        : `${docTemplates[0].prefix} ${docTemplates[0].name} export`.slice(0, 100),
      send_notification: false,
    },
  };
};
